import React from "react";
import * as d3 from "d3";
import { choroplethChart } from './helpers/ChoroplethHelper';
import { stateConverter } from "./helpers/stateConverter";
import moment from 'moment';
import * as orderStatsService from "../services/orderStats.service";
import * as opOrderStatsService from "../services/openprintStats.service";
import * as spOrderStatsService from "../services/subprintStats.service";
import * as ipOrderStatsService from "../services/iprintStats.service";

class LocationStateChart extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      spin: false
    }
  }
  componentDidMount() {
    let service;
    if (this.props.system === 'PV') {
      service = orderStatsService;
    } else if (this.props.system === 'OP') {
      service = opOrderStatsService;
    } else if (this.props.system === 'SP') {
      service = spOrderStatsService;
    } else if (this.props.system === 'IP') {
      service = ipOrderStatsService;
    }
    this.setState({
      spin: true,
    });
    service.getPopularLocation('week', 'state').then(response => {
      //console.log(response);
      //console.log("Order Map");
      //console.log(this.props.time);
      //console.log(this.props.location);
      let currTime = this.props.time;
      let timeObj;
      if (currTime === 'week') {
        timeObj = JSON.parse(response.week);
      } else if (currTime === 'month') {
        timeObj = JSON.parse(response.month);
      } else if (currTime === 'year') {
        timeObj = JSON.parse(response.year);
      } else if (currTime === 'lastYear') {
        timeObj = JSON.parse(response.lastYear);
      } else{
        timeObj = JSON.parse(response.season);
      }

      let mapReadyObj = this.mapTransform(timeObj.quantity);
      //console.log("MAP Transform Results");
      //console.log(mapReadyObj);
      this.drawChart(mapReadyObj[0], mapReadyObj[1], mapReadyObj[2]);
    //   console.log(timeObj);
    //   console.log(mapReadyObj);
    }).catch(err => {
      console.log(err);
    })
  }

  drawChart = (data, max, min) => {
    let chart;
    //console.log(data);
    chart = choroplethChart(data, max, min);
    //console.log(chart)
    this.setState({
      spin: false,
    });
    d3.select('#chart_' + this.props.type + this.props.time).exit().remove()
    d3.select('#chart_' + this.props.type + this.props.time).node().append(chart)
    //console.log(chart)
    return chart;
  }

  mapTransform = (obj) => {
    let finalArr = [];
    let max = Number.NEGATIVE_INFINITY;
    let min = Number.POSITIVE_INFINITY;
    let keys = Object.keys(obj);
    //console.log("Locations Object Keys");
    //console.log(keys);
    for (let i=0; i < keys.length; i++) {
      let state = keys[i];
      //console.log(state);
      let fullState = stateConverter[state];
      let stateValue = obj[state];
      //console.log(fullState);
      if (fullState) {
        //console.log("Success!");
        if (!+stateValue) {
          stateValue = 0;
        }
        let stateArr = [fullState, +stateValue];
        //console.log(`IS ${stateValue} > ${max}`);
        //console.log(+stateValue > max);
        if ((+stateValue > max) & (+stateValue)) {
          max = +stateValue;
        }
        //console.log(`IS ${stateValue} < ${min}`);
        //console.log(+stateValue < min);
        if ((+stateValue < min) & (+stateValue)) {
          min = +stateValue;
        }
        finalArr.push(stateArr);
      }
    }
    // console.log(finalArr);
    // console.log("MAX");
    // console.log(max);
    // console.log("MIN");
    // console.log(min);
    return [finalArr, max, min];
  } 

  render() {
    return(
      <div className='mt-2'>
        {this.state.spin ? 
        <svg role="status" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg> : null}
        {!this.state.spin ? <h5 className="ml-4">{this.props.title}</h5> : null}
        <div id={'chart_' + this.props.type + this.props.time} className="ml-4" />
      </div>
    )
  }
}

export default LocationStateChart;